import type { MaintenanceResourceModel } from 'api/models';

export const EXECUTION_MODES = [
  'BelongPro',
  'HomeownerPro',
  'HomeownerFixing',
  'ResidentFixing',
] as const;

export type ExecutionMode = (typeof EXECUTION_MODES)[number];

type HomeownerProResource = {
  partnerId: number;
  name?: string | null;
  phone?: string | null;
  email?: string | null;
  isOnboarded: boolean;
  onboardedOn?: string | null;
};

export type HomeownerProInput = {
  name: string;
  company?: string;
  phone?: string;
  email?: string;
};

type ExecutionModeMaintenance = MaintenanceResourceModel & {
  executionMode?: ExecutionMode | null;
  homeownerPro?: HomeownerProResource | null;
  homeownerProInput?: HomeownerProInput;
};

type ReportItemPayment = {
  paidBy: string;
  percentage?: number;
  flagged?: boolean;
  consentStatus?: string;
  [key: string]: unknown;
};

export type ReportItem = {
  maintenance: ExecutionModeMaintenance;
  maintenancePayments: ReportItemPayment[];
  isTBD?: boolean;
  [key: string]: unknown;
};

export type ImprovementPresets = Record<
  string,
  { allowHomeownerFixing?: boolean; code?: string } | undefined
>;

export type ExecutionModePatch = {
  executionMode: ExecutionMode;
  homeownerProInput?: HomeownerProInput;
};

export type ReusablePro = {
  partnerId: number;
  name: string;
  phone?: string;
  email?: string;
  trades: string[];
};

export type ProFormValues = {
  firstName?: string;
  lastName?: string;
  company?: string;
  phone?: string;
  email?: string;
};

export type ProFormErrors = Partial<Record<keyof ProFormValues, string>>;

export type ExecutionChoice = 'BelongPro' | 'HomeownerPro';

export type ExecutionModeFormValues = {
  executionChoice?: ExecutionChoice;
  manageProMyself?: boolean;
  homeownerProChoice?: string;
  homeownerPro?: ProFormValues;
  flagged?: boolean;
};

export type SelectorState = {
  showSelector: boolean;
  buttonsDisabled: boolean;
  manageMyselfDisabled: boolean;
  showWarning: boolean;
  showProPicker: boolean;
  showProForm: boolean;
  ctaLabel: string;
};

export type CardLabel =
  | 'discuss'
  | 'belongPro'
  | 'ownPro'
  | 'homeownerFixing'
  | null;

export type HomeownerProSource = 'new' | 'reused';
